const STORAGE_KEY = "pendingSignup";
const VERIFICATION_KEY = "pendingVerificationEmail";

export type SignupMethod = "email" | "google";

/** Matches the backend `YESnNO` enum — anything else fails validation on POST /users. */
export type YesNo = "Yes" | "No";

/**
 * Draft of the account being created, handed from /register -> /onboarding -> /creating-profile.
 * Replaces the old pre-auth "savedPreferences" blob, which held the whole questionnaire.
 */
export interface PendingSignup {
	firstName: string;
	lastName: string;
	email: string;
	phone?: string;
	method: SignupMethod;
	/** Filled in by the onboarding step. */
	jobTitle?: string;
	areasOfExpertise?: string[];
	recentGraduate?: YesNo;
	/** Month name as shown in the dropdown; converted to a number for the API. */
	experienceMonth?: string;
	experienceYear?: string;
	/** Derived from the date above rather than asked — see ./seniority. */
	seniorityLevel?: string;
}

export function getPendingSignup(): PendingSignup | null {
	try {
		const raw = localStorage.getItem(STORAGE_KEY);
		return raw ? (JSON.parse(raw) as PendingSignup) : null;
	} catch {
		return null;
	}
}

export function setPendingSignup(pendingSignup: PendingSignup) {
	localStorage.setItem(STORAGE_KEY, JSON.stringify(pendingSignup));
}

export function clearPendingSignup() {
	localStorage.removeItem(STORAGE_KEY);
}

/**
 * Set once the account exists but the email link hasn't been followed yet. Keeps the
 * "check your email" screen (and its resend button) reachable across a page refresh without
 * re-POSTing the user.
 */
export function setPendingVerificationEmail(email: string) {
	localStorage.setItem(VERIFICATION_KEY, email);
}

export function getPendingVerificationEmail(): string | null {
	return localStorage.getItem(VERIFICATION_KEY);
}

export function clearPendingVerificationEmail() {
	localStorage.removeItem(VERIFICATION_KEY);
}
